import { DailyOrderStatsDoc } from '@gooduncles/gu-app-schema';
import { AvailableYearForStats } from 'src/constants';
import { WHERE } from 'src/utils/firebase/firebase-manager';
import { getDailyOrderStats } from 'src/utils/firebase/firebase-short-cut';
import { BareFetcher } from 'swr';
import useImmutableSWR from 'swr/immutable';

type options = {
  selectedYears: AvailableYearForStats[];
};

const fetcher: BareFetcher<DailyOrderStatsDoc[]> = ([, options]: [string, options]) => {
  const where: WHERE[] = options.selectedYears ? [['year', 'in', options.selectedYears]] : [];
  return getDailyOrderStats(where);
};

const useDailyOrderStats = (options: options) => {
  const { data: dailyOrderStats, isValidating: dailyOrderStatsLoading } = useImmutableSWR(
    options.selectedYears.length > 0 ? ['dailyOrderStats', options] : null,
    fetcher
  );

  return {
    dailyOrderStats,
    dailyOrderStatsLoading,
  };
};

export default useDailyOrderStats;
